var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "accordion-item",
      class: [_vm.bemIf(_vm.isItemOpen, "open"), _vm.bemFacets]
    },
    [
      _c("div", { staticClass: "accordion-item--container" }, [
        _c("div", { staticClass: "accordion-item--row" }, [
          _c(
            "div",
            { staticClass: "accordion-item--col" },
            [
              _c(
                "div",
                {
                  staticClass: "accordion-item--title-wrapper",
                  attrs: { tabindex: "0" },
                  on: { click: _vm.onOpen }
                },
                [
                  _vm._t("title", [
                    _c("h3", { staticClass: "u-reset accordion-item--title" }, [
                      _vm._v(_vm._s(_vm.label))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "accordion-item--indicator-col" }, [
                    _c(
                      "button",
                      { staticClass: "u-reset accordion-item--indicator" },
                      [
                        _vm._t("icon", [
                          _c("base-icon", {
                            attrs: { symbol: "chevron-down", size: "small" }
                          })
                        ])
                      ],
                      2
                    )
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "transition",
                {
                  attrs: { name: "trs-accordion" },
                  on: {
                    "before-enter": _vm.beforeEnter,
                    enter: _vm.enter,
                    "before-leave": _vm.beforeLeave,
                    leave: _vm.leave
                  }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isItemOpen,
                          expression: "isItemOpen"
                        }
                      ],
                      staticClass: "accordion-item--content"
                    },
                    [
                      _vm._t("content", [
                        _c("div", {
                          staticClass: "u-raw-text",
                          domProps: { innerHTML: _vm._s(_vm.content) }
                        })
                      ]),
                      _vm._v(" "),
                      _vm._t("default")
                    ],
                    2
                  )
                ]
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-958c300a", { render: render, staticRenderFns: staticRenderFns })
  }
}